import './App.css'
import { ConfigProvider } from 'antd'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './Core/Auth/AuthContext'
import ProtectedRoute from './Core/Auth/ProtectedRoute'
import Login from './Modules/Auth/Login'
import Dashboard from './Modules/Dashboard/Dashboard'
import AlloyRegistration from './Modules/Alloy Registration/alloyRegistration'

function App () {
  return (
    <BrowserRouter>
      <ConfigProvider>
        <div className='App'>
          <AuthProvider>
            <Routes>
              {/* Public Routes */}
              <Route
                path='/login'
                element={
                  <ProtectedRoute requiresAuth={false}>
                    <Login />
                  </ProtectedRoute>
                }
              />

              {/* Protected Routes - Require Dealer Authentication */}
              <Route
                path='/dashboard'
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />

              <Route
                path='/alloy-registration'
                element={
                  <ProtectedRoute>
                    <AlloyRegistration />
                  </ProtectedRoute>
                }
              />

              {/* Default redirect to alloy registration (main function for dealers) */}
              <Route
                path='/'
                element={<Navigate to='/alloy-registration' replace />}
              />

              {/* Catch all route - redirect to alloy registration */}
              <Route
                path='*'
                element={<Navigate to='/alloy-registration' replace />}
              />
            </Routes>
          </AuthProvider>
        </div>
      </ConfigProvider>
    </BrowserRouter>
  )
}

export default App
